import Login from './Pages/Login';

import { Routes, Route } from 'react-router-dom';

import Home from './Pages/Home';

import { RequireAuth } from './Services/Auth/sessionAuth';

import './App.css';

import { AgenceProvider } from './AgenceContext';

import MfaActivationPage from './Components/Mfa/MfaActivationPage';

import MfaVerifyPage from './Components/Mfa/MfaVerifyPage';



function App() {

  return (

    <div className="App" >

      <AgenceProvider>

        <Routes>

        <Route path='/Login' element={<Login />} />

        <Route

          path='/mfa-activation'

          element={

            <RequireAuth loginPath={'/Login'} >

              <MfaActivationPage />

            </RequireAuth>

          }

        />

        <Route

          path='/mfa-verify'

          element={

            <RequireAuth loginPath={'/Login'} >

              <MfaVerifyPage />

            </RequireAuth>

          }

        />

        <Route

          path='/*'

          element={

            <RequireAuth loginPath={'/Login'} >

              <Home/>

            </RequireAuth>

          }

        />

        <Route path='*' element={

          <RequireAuth loginPath={'/Login'} >

            <Home />

          </RequireAuth>

        } />

      </Routes>

      </AgenceProvider>

      

    </div>

  );

}



export default App;

